const churches = [
  'bandal  i',
  'bandal  ii',
  'barumbu',
  'bikuku',
  'binza/delvaux',
  'binza/upn',
  'binzai(siege)',
  'bita',
  'bumbu  i',
  'bumbu  ii  (siege)',
  'camp luka',
  'camp munganga',
  'camping',
  'don bosco',
  'funa',
  'kasa-vaba',
  'kauka',
  'kimbangu',
  'kimbanseke  i',
  'kimbanseke  ii',
  'kimbanseke  iii',
  'kimwenza',
  'kingabwa',
  'kingabwaii',
  'kingasani  i(siege)',
  'kingasani  ii',
  'kinkole  i',
  'kinkole  ii',
  'kinkole  iii',
  'kisenso ',
  'kitambo',
  'kwenge(siege)',
  'lemba',
  'lingwala',
  'livulu',
  'makala',
  'malueka',
  'maluku  i',
  'maluku  ii',
  'masina  i',
  'masina  ii',
  'masina  iii',
  'matadi kibala',
  'matete',
  'mbudi',
  'menkao',
  'mikondo  i',
  'mikondo  ii  ',
  'mikonga  i',
  'mikonga  ii',
  'mikonga efobank',
  'mitendi',
  'mokali  i',
  'mokali  ii',
  'mombele',
  'mont ngafula',
  'mpasa maba',
  'ndjili  i',
  'ndjili  ii',
  'ndjili  iii',
  'ngaba',
  'ngiri-ngiri',
  'nsanga mamba',
  'nsele',
  'rond point ngaba',
  'ruff-laert',
  'yolo',
];
export {
  churches,
};



// WEBPACK FOOTER //
// ./src/api/churches.js